// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"715":"list","962":"home","996":"chunk-common"}[chunkId] || chunkId) + "." + {"570":"62940b08","715":"e122f39f","962":"39edb107","996":"ab282cf5"}[chunkId] + ".js";
};